const COUNTRY_CODE = '90';
const MOBILE_LENGTH = 10;

export function phoneDigits(value) {
  let digits = String(value || '').replace(/\D/g, '');
  if (digits.startsWith(COUNTRY_CODE)) digits = digits.slice(COUNTRY_CODE.length);
  if (digits.startsWith('0')) digits = digits.slice(1);
  return digits;
}

export function isPhoneComplete(value) {
  const digits = phoneDigits(value);
  return digits.length === MOBILE_LENGTH && digits.startsWith('5');
}

export function normalizePhone(value) {
  const digits = phoneDigits(value);
  if (!digits) return '';
  if (digits.length === MOBILE_LENGTH && digits.startsWith('5')) {
    return `+${COUNTRY_CODE}${digits}`;
  }
  const raw = String(value || '').replace(/\D/g, '');
  return raw.startsWith(COUNTRY_CODE) ? `+${raw}` : '';
}

export function formatPhoneDisplay(value) {
  const digits = phoneDigits(value).slice(0, MOBILE_LENGTH);
  const parts = [];
  if (digits.length > 0) parts.push(digits.slice(0, 3));
  if (digits.length > 3) parts.push(digits.slice(3, 6));
  if (digits.length > 6) parts.push(digits.slice(6, 8));
  if (digits.length > 8) parts.push(digits.slice(8, 10));
  return parts.join(' ').trim();
}

export function formatPhoneInput(raw) {
  const digits = phoneDigits(raw).slice(0, MOBILE_LENGTH);
  const spaced = formatPhoneDisplay(digits);
  return spaced ? `+90 ${spaced}`.trim() : '';
}

export function phonePlaceholder() {
  return '+90 5XX XXX XX XX';
}
